<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import { eventBus } from '@/event_bus.js'
import { Sortable, Swap } from 'sortablejs/modular/sortable.core.esm'

Sortable.mount(new Swap())

export default {
  name: 'ElementSort',
  props: {
    vid: String,
    init_step_historys: Array,
    init_step_history_index: Number,
  },
  data() {
    return {
      sort_img_list: [],
      regain_data_list: [],
      regain_index: -1,
      is_changed_sort: false,
      dialog_status: false,
      step_historys: [],
      step_history_index: -1,
    }
  },
  computed: {
    toolbox_title_btn() {
      return [
        // {
        //   icon: 'mdi-history',
        //   disabled: !this.is_changed_sort,
        //   onclick: this.resetSort,
        // },
        {
          icon: 'mdi-arrow-u-left-top',
          disabled: this.step_history_index < 0,
          onclick: this.regain_previous,
        },
        {
          icon: 'mdi-arrow-u-right-top',
          disabled: this.step_history_index === this.step_historys.length - 1,
          onclick: this.regain_next,
        },
      ]
    },
    ...mapGetters('optimize', ['catch_iframe_selected_data', 'reset_editor_data']),
  },
  watch: {
    regain_data_list: {
      handler(newValue) {
        this.regain_index = newValue.length - 1
      },
      deep: true,
    },
    catch_iframe_selected_data: {
      handler(newValue) {
        console.log('catch_la', newValue)

        // 目前只處理圖片
        if (!['IMG'].includes(newValue.selected_element_info.nodeName) || !newValue.el_pageY) {
          return
        }
        if (newValue.update_result) {
          return
        }
        // 修改過排序後，再次選取圖片將初始化排序的資料
        if (this.is_changed_sort) {
          this.sort_img_list = []
          this.is_changed_sort = false
        }
        // 重複點擊則從清單刪除
        const repeat_click_item_index = this.sort_img_list.findIndex(
          (item) => item.selected_element_selector === newValue.selected_element_selector
        )
        if (repeat_click_item_index !== -1) {
          return this.sort_img_list.splice(repeat_click_item_index, 1)
        }

        const new_data = {
          seat_id: newValue.data_sort_id,
          url: newValue.selected_element_info.attributes.src,
          pageY: newValue.el_pageY,
          selected_element_info: newValue.selected_element_info,
          selected_element_selector: newValue.selected_element_selector,
          node_name: newValue.selected_element_info.nodeName,
        }
        const data = [...this.sort_img_list]
        data.push(new_data)
        data.sort((a, b) => a.pageY - b.pageY)
        this.sort_img_list = data

        console.log('sort_img_list', this.sort_img_list)
      },
      deep: true,
    },
    // sort_img_list: {
    //   handler(newValue) {
    //     // 送變更資料到 header 以便儲存
    //     if (this.is_changed_sort || !newValue.length) {
    //       eventBus.$emit('update-header-history', this.regain_data_list, this.regain_index)
    //     }
    //   },
    // },
  },
  created() {
    eventBus.$on('update-sort-result', this.updateSortResult)
    this.step_historys = this.init_step_historys
    this.step_history_index = this.init_step_history_index
  },
  mounted() {
    new Sortable(document.querySelector('.element-sort-toolbox-content'), {
      swap: true,
      forceFallback: true,
      swapClass: 'sort-preview-seat',
      animation: 150,
      onUpdate: (e) => {
        console.log('trigger-sort-update')
        this.is_changed_sort = true
        this.sendPostMessage(e, false, 'next')
      },
    })
  },
  async beforeDestroy() {
    // 切換編輯工具時點擊重置
    if (this.reset_editor_data) {
      await this.resetSort()
      store.commit('optimize/RESET_EDITOR_DATA', false)
    }
  },
  methods: {
    sendPostMessage(e_or_data, is_by_step, type) {
      console.log('e_or_data_1', e_or_data)
      let data = {}
      if (!is_by_step) {
        data = {
          action: 'sortElement',
          data: {
            vid: this.vid,
            is_by_step: false,
            type: type,
            payload: {
              from_seat_id: this.sort_img_list[e_or_data.oldIndex].seat_id,
              from: this.sort_img_list[e_or_data.oldIndex].selected_element_selector,
              to_seat_id: this.sort_img_list[e_or_data.newIndex].seat_id,
              to: this.sort_img_list[e_or_data.newIndex].selected_element_selector,
              type: 'sort_element',
              selector: this.sort_img_list[e_or_data.newIndex].selected_element_selector,
              oldIndex: e_or_data.oldIndex,
              newIndex: e_or_data.newIndex,
              is_by_step: false,
              from_node_name: this.sort_img_list[e_or_data.newIndex].node_name,
            },
            oldIndex: e_or_data.oldIndex,
            newIndex: e_or_data.newIndex,
          },
        }
      } else {
        data = {
          action: 'sortElement',
          data: {
            vid: this.vid,
            is_by_step: true,
            type: type,
            payload: {
              ...e_or_data,
              is_by_step: true,
            },
          },
        }
      }

      console.log('post_data', data)

      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', data)

      // if (e_or_data.is_reset) {
      //   return this.updateSortData(e_or_data)
      // }

      // if (e_or_data.is_regain) {
      //   return
      // }

      // default: 一般操作就要儲存異動紀錄
      // this.regain_data_list.splice(this.regain_index + 1, this.regain_data_list.length - 1 - this.regain_index, {
      //   oldIndex: e_or_data.oldIndex,
      //   newIndex: e_or_data.newIndex,
      // })
      if (!is_by_step) {
        this.updateSortData(e_or_data)
      }
    },
    // 因使用 SortableJS，所以需要手動更新數據
    updateSortData(data) {
      console.log('updateSortData', data)

      const curr_list = this.sort_img_list
      const temp = curr_list[data.newIndex]
      curr_list.splice(data.newIndex, 1, curr_list[data.oldIndex])
      curr_list.splice(data.oldIndex, 1, temp)
      this.sort_img_list = curr_list
    },
    regain_previous() {
      if (this.step_history_index < 0) {
        return
      }

      console.log('prev', this.step_historys[this.step_history_index])
      this.sort_img_list = []
      console.log('this.sort_img_list', this.sort_img_list.length)
      if (this.step_historys[this.step_history_index].type !== 'sort_element') {
        // 同步紀錄給header
        this.handleHistory('previous', false)
        return
      }

      // 真的修改網頁的順序
      this.sendPostMessage(this.step_historys[this.step_history_index], true, 'previous')

      // 修改編輯器順序
      this.updateSortData(this.step_historys[this.step_history_index])

      // 同步紀錄給header
      this.handleHistory('previous')
    },
    regain_next() {
      if (this.step_history_index === this.step_historys.length - 1) {
        return
      }
      this.sort_img_list = []
      if (this.step_historys[this.step_history_index + 1].type !== 'sort_element') {
        // 同步紀錄給header
        this.handleHistory('next', false)
        return
      }

      // 真的修改網頁的順序
      this.sendPostMessage(this.step_historys[this.step_history_index + 1], true, 'previous')

      // 修改編輯器順序
      this.updateSortData(this.step_historys[this.step_history_index + 1])

      // 同步紀錄給header
      this.handleHistory('next')
    },
    resetSort() {
      if (this.regain_index === -1) {
        this.initData()
      } else {
        for (let i = this.regain_data_list.length - 1; i >= 0; i--) {
          if (i <= this.regain_index) {
            // 連打會壞掉，所以用 setTimeout 包
            setTimeout(() => {
              this.sendPostMessage({
                ...this.regain_data_list[i],
                is_reset: true,
              })

              if (i === 0) {
                this.initData()
              }
            }, 0)
          }
        }
      }

      this.dialog_status = false
    },
    initData() {
      this.regain_data_list = []
      this.regain_index = -1
      this.sort_img_list = []
      this.is_changed_sort = false
    },
    save() {
      eventBus.$emit('save-these-operates', true)
      this.dialog_status = false
      this.initData()
    },
    updateSortResult(data) {
      console.log('elementSort-updateSortResult', data)
      if (!data.is_need_update_history) {
        return
      }
      this.sort_img_list = this.sort_img_list.filter((item) => {
        return item !== undefined
      })

      console.log('this.sort_img_list', this.sort_img_list)
      let list_from = this.sort_img_list.findIndex((item) => {
        return item.seat_id === data.platform_step.from_seat_id
      })
      console.log('list_from', list_from)
      if (list_from === -1) {
        return
      }
      this.sort_img_list[list_from].selected_element_selector = data.update_result.callback_data.new_from_selector

      let list_to = this.sort_img_list.findIndex((item) => {
        return item.seat_id === data.platform_step.to_seat_id
      })
      console.log('list_to', list_to)
      if (list_to === -1) {
        return
      }
      this.sort_img_list[list_to].selected_element_selector = data.update_result.callback_data.new_to_selector

      let step = {
        from_seat_id: data.platform_step.from_seat_id,
        to_seat_id: data.platform_step.to_seat_id,
        new_from: data.update_result.callback_data.new_from_selector,
        new_to: data.update_result.callback_data.new_to_selector,
        from: data.platform_step.from,
        to: data.platform_step.to,
        newIndex: data.platform_step.newIndex,
        oldIndex: data.platform_step.oldIndex,
        selector: data.platform_step.from,
        type: 'sort_element',
        original_info: {
          nodeName: data.platform_step.from_node_name,
        },
      }
      this.recordHistory(step)

      console.log('sort_img_list', this.sort_img_list)
    },
    recordHistory: function (data) {
      let step_historys = this.step_historys
      let idx = this.step_history_index

      // 把目前這index當作最新的，之後的全刪掉
      step_historys.splice(idx + 1, step_historys.length - idx - 1)
      // 推進去歷史紀錄
      step_historys.push(data)
      idx = step_historys.length - 1

      eventBus.$emit('update-header-history', step_historys, idx)
      this.step_historys = step_historys
      this.step_history_index = idx
    },
    updateHistory: function (historys, history_idx) {
      this.step_historys = historys
      this.step_history_index = history_idx
    },
    handleHistory: async function (step_type, is_current_feature) {
      let idx = this.step_history_index

      if (step_type === 'next') {
        console.log('下一步')
        idx += 1
      } else {
        console.log('上一步')
      }

      const ele = this.step_historys[idx]
      console.log('idx', idx)
      console.log('ele', ele)

      if (step_type !== 'next') {
        this.step_history_index = idx - 1
        await eventBus.$emit('update-header-history', this.step_historys, this.step_history_index)
        // await eventBus.$off('update-editor-history', this.updateHistory);
        await eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index)
        // eventBus.$on('update-editor-history', this.updateHistory);
      } else {
        this.step_history_index = idx
        await eventBus.$emit('update-header-history', this.step_historys, this.step_history_index)
        // await eventBus.$off('update-editor-history', this.updateHistory);
        await eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index)
        // eventBus.$on('update-editor-history', this.updateHistory);
      }
      if (is_current_feature === false) {
        eventBus.$emit('update-selected-element', ele, step_type, true)
      }
      console.log('sort-handle history', this.step_history_index)
    },
  },
}
</script>

<template>
  <div>
    <v-card class="element-sort-toolbox" :width="280" :min-height="400">
      <v-card-title class="element-sort-toolbox-title primary py-0 justify-end">
        <v-btn
          v-for="(btn_info, index) in toolbox_title_btn"
          :key="index"
          text
          icon
          :disabled="btn_info.disabled"
          :width="36"
          @click="btn_info.onclick()"
        >
          <v-icon color="white" :size="20" v-text="btn_info.icon" />
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="element-sort-toolbox-content">
          <v-row v-for="item in sort_img_list" :key="item.seat_id" class="mt-4" no-gutters align="center">
            <v-col cols="8">
              <v-img height="100" width="150" :src="item.url" />
            </v-col>
            <v-col class="d-flex justify-end">
              <v-icon v-text="'mdi-menu'" />
            </v-col>
          </v-row>
        </div>
        <p v-if="!sort_img_list.length" class="text-center text-body-1 mt-4" v-text="'請點選任一圖片'" />
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_status" max-width="600">
      <v-card>
        <v-card-title class="primary white--text">是否重新排序</v-card-title>
        <v-card-text class="pa-5">重新排序須先存檔或者重置</v-card-text>
        <v-card-actions class="justify-space-around">
          <v-btn @click="resetSort()" v-text="'重置'" />
          <v-btn color="primary" @click="save()" v-text="'存檔'" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.element-sort-toolbox {
  position: fixed;
  left: 15px;
  bottom: 15px;
  z-index: 3;

  .element-sort-toolbox-title {
    height: 50px;
  }

  .element-sort-toolbox-content {
    cursor: pointer;

    .no-select {
      user-select: none;
    }
  }
}

.sort-preview-seat {
  background: gray;
  opacity: 0.6;
}
</style>
